// removed by extract-text-webpack-plugin
module.exports = {"intro":"src-pages----articles-module---intro---3XsMc","listOuter":"src-pages----articles-module---listOuter---rznfC","list":"src-pages----articles-module---list---XZjut"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/articles.module.css
// module id = 655
// module chunks = 174759553322802